import {SunnyIcon, CloudyIcon, GreyIcon, RainyIcon, StormyIcon} from './icons'

export const RATING = [
  {
    title: 'Sunny',
    icon: SunnyIcon,
  },
  {
    title: 'Grey',
    icon: GreyIcon,
  },
  {
    title: 'Cloudy',
    icon: CloudyIcon,
  },
  {
    title: 'Rainy',
    icon: RainyIcon,
  },
  {
    title: 'Stormy',
    icon: StormyIcon,
  },
]
